import DiagContents from '@di-shared/features/diag/DiagContents';
import React, {Suspense} from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import HomeSestExchangeHistoryKr from '@di-shared/features/home/kr/vehicle/HomeSestExchangeHistory.kr';
import environmentStore from '@di-shared/features/environment/environmentStore';

export interface DiagPageProps {
  vin: string;
}

function DiagPage({vin}: DiagPageProps) {
  const ccid = environmentStore.getState().ccid;
  return (
    <>
      <ScrollToTopOnMount />
      <DiagContents
        vin={vin}
        ccid={ccid}
      />
      <Suspense>
        <HomeSestExchangeHistoryKr vin={vin} />
      </Suspense>
    </>
  );
}

export default DiagPage;
